import { ActionTypes } from '../actions';

const initialState = {
  roles: [],
  selectedRole: {},
};

const RoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_ALL_ROLES:
      return { ...state, roles: action.payload };

    case ActionTypes.SET_SELECTED_ROLE:
      return { ...state, selectedRole: state.roles.find(r => r._id === action.payload) || initialState.selectedRole };

    case ActionTypes.CLEAR_SELECTED_ROLE:
      return { ...state, selectedRole: initialState.selectedRole };

    default:
      return state;
  }
};

export default RoleReducer;
